import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Welcome from './Welcome';
import Contribution from './Contribution.js'
import App from './App.js';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import * as firebase from 'firebase';

// Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyBWSVUpoQ9Nwjopwwz0IYBPSu3mzchSjaE",
  authDomain: "ds-interview-fdcb3.firebaseapp.com",
  databaseURL: "https://ds-interview-fdcb3.firebaseio.com",
  projectId: "ds-interview-fdcb3",
  storageBucket: "ds-interview-fdcb3.appspot.com",
  messagingSenderId: "179469168980",
  appId: "1:179469168980:web:7b0e7a90705373834c58c1",
  measurementId: "G-5NGESK5WT5"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(

  <React.StrictMode>
    <Router>
      <Route exact path="/" component={() => <Welcome />}></Route>
      <Route exact path="/questions" component={() => <App />}></Route>
      <Route exact path="/contribution" component={() => <Contribution />}></Route>
    </Router>  
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
